export const store = {
    mainNavExpanded: false,
    infoNavExpanded: false,
    gApi: window.global?.googleMapApi ?? null,
    gMapId: window.global?.googleMapId ?? 'DEMO_MAP_ID',
    _fixedHeaderOffset: null,
    get fixedHeaderOffset() {
        if (this._fixedHeaderOffset === null) {
            const headerStack = document.querySelector('.header-stack');
            this._fixedHeaderOffset = (headerStack?.offsetHeight ?? 0) + 10;
        }
        return this._fixedHeaderOffset;
    },
};
